module.exports = __webpack_public_path__ + "img/cat (2).be0433e7.jpg";